import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import PageBase from 'components/common/PageBase';
import DetailsPage from 'containers/detailsPage/DetailsPage';

class ICNPlusPageDetails extends Component {
    render() {
        const { translate} = this.props;
        return (
            <PageBase title={translate('ICNPlusDetailsForm.title')} showGoToButtons={true} showDownloadButtons={true} id={this.props.params.id} isIcnPlus={true} isDent={false}  >
                <DetailsPage id={this.props.params.id} isIcnPlus={true} isDent={false} />
            </PageBase>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    };
}

export default connect(mapStateToProps)(ICNPlusPageDetails);


// WEBPACK FOOTER //
// ./src/pages/icnplus/ICNPlusPageDetails.js